/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Proof_Panel_Row4Inputs */

const en_mk_proof_panel_row4 = /** @type {(inputs: Mk_Proof_Panel_Row4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Screenshot: form error state`)
};

const id_mk_proof_panel_row4 = /** @type {(inputs: Mk_Proof_Panel_Row4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tangkapan layar: form dalam kondisi error`)
};

/**
* | output |
* | --- |
* | "Screenshot: form error state" |
*
* @param {Mk_Proof_Panel_Row4Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_proof_panel_row4 = /** @type {((inputs?: Mk_Proof_Panel_Row4Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Proof_Panel_Row4Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_proof_panel_row4(inputs)
	return en_mk_proof_panel_row4(inputs)
});